var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.7,
    fill: "#FFF",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70B8CB",
    fillRule: "nonzero",
    d: "M29.04925105 31.38577779l-5.43408683-5.43408683-5.54925105 5.54925105-2.5395482-2.5395482 5.54925105-5.54925105-5.46139381-5.46139381 2.36307817-2.36307818 5.46139382 5.46139382 5.52269961-5.52269962 2.5395482 2.5395482-5.52269962 5.52269961 5.43408684 5.43408684z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.bbd0f38b3a1bd112781bbc93e2b8668c.svg";
export { ForwardRef as ReactComponent };